import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { canPerform } from "./actions"

/**
 * Wraps the customer product (`/app/...`, `/customer-picker`). Redirects platform
 * users without `app.customers` (e.g. traders) to `/admin`. Assumes AuthGuard
 * has already verified authentication.
 */
export function RequireCustomerApp({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-content-2">Loading...</div>
      </div>
    )
  }

  if (!canPerform(user?.platformRole, "app.customers")) {
    return <Navigate to="/admin" replace />
  }

  return <>{children}</>
}
